import cn from 'classnames';
import type { MetricCardsBlock as MetricCardsBlockType } from '../types';
import { BlockEmptyState } from './BlockEmptyState';

// ─────────────────────────────────────────────
// MetricCardsBlock — KPI 卡片组
// Figma: 两列网格 / 每卡片圆角12px + 灰色边框 + 灰底
// direction: up=绿色▲ / down=红色▼ / null=—
// ─────────────────────────────────────────────
export function MetricCardsBlock({ block }: { block: MetricCardsBlockType }) {
  const cards = block.cards ?? [];
  if (cards.length === 0) return <BlockEmptyState label="核心指标" />;

  return (
    <div className="grid grid-cols-2 gap-3">
      {cards.map((card, idx) => (
        <div key={idx} className="flex flex-col gap-2 px-5 py-4 bg-[#FAFAFA] border border-[#E5E5E5] rounded-[12px]">
          <span className="text-[14px] leading-[150%] tracking-[0.005em] text-[#737373]">{card.label}</span>
          <div className="flex items-end gap-4 flex-wrap">
            <span className="text-[24px] font-semibold leading-[120%] tracking-[-0.02em] text-[#262626]">
              {card.value}
            </span>
            {card.change ? (
              <span
                className={cn(
                  'text-[14px] leading-[150%] tracking-[0.005em]',
                  card.direction === 'up'
                    ? 'text-[#047857]'
                    : card.direction === 'down'
                      ? 'text-[#DC2626]'
                      : 'text-[#737373]'
                )}
              >
                {card.direction === 'up' ? '▲ ' : card.direction === 'down' ? '▼ ' : ''}
                {card.change}
              </span>
            ) : (
              <span className="text-[14px] text-[#A3A3A3]">—</span>
            )}
          </div>
          {/* {card.hint && <span className="text-[11px] text-[#A3A3A3] leading-[1.4]">{card.hint}</span>} */}
        </div>
      ))}
    </div>
  );
}
